<template>
  <div>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/build' }"
          >党建专栏</el-breadcrumb-item
        >
        <el-breadcrumb-item>党建详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <h2>党的二十大主题的深邃意蕴</h2>
        <p style="text-align: right"><span style="margin-right: 60px">2022-10-22</span></p>
        <p>党的二十大的主题是：高举中国特色社会主义伟大旗帜，全面贯彻新时代中国特色社会主义思想，弘扬伟大建党精神，自信自强、守正创新，踔厉奋发、勇毅前行，为全面建设社会主义现代化国家、全面推进中华民族伟大复兴而团结奋斗。这一鲜明主题是对党在新征程上举什么旗、走什么路、以什么样的精神状态、朝着什么样的目标继续前进的郑重宣示。</p>
        <p>中国特色社会主义是新征程上高举的伟大旗帜</p>
        <p>旗帜决定方向，方向决定道路，道路决定命运。中国特色社会主义是改革开放以来党和国家理论和实践的全部主题。1982年，在党的十二大上，邓小平同志提出，走自己的道路，建设有中国特色的社会主义。从1987年召开的党的十三大起，历次党代会的主题都高举中国特色社会主义伟大旗帜。中国共产党始终牢牢立足社会主义初级阶段这个最大实际，牢牢坚持党的基本路线这个党和国家的生命线、人民的幸福线，高举中国特色社会主义伟大旗帜，坚持走中国特色社会主义道路。党的二十大的主题强调高举中国特色社会主义伟大旗帜，凝结着中国共产党对共产党执政规律、社会主义建设规律、人类社会发展规律的深刻认识，吹响了奋进新时代、启航新征程的号角，必将激励中国共产党和中国人民坚持党的基本路线不动摇，坚定道路自信、理论自信、制度自信、文化自信，沿着中国特色社会主义道路阔步前进、永远奋斗。</p>
        <p>习近平新时代中国特色社会主义思想是新征程上党和国家必须全面贯彻的根本指导思想</p>
        <p>在百年奋进征程中，中国共产党坚持不懈用马克思主义中国化最新成果武装全党，书写了思想建党、理论强党的精彩之笔。党的十八大以来，我们党把马克思主义基本原理同中国具体实际相结合、同中华优秀传统文化相结合，提出一系列治国理政新理念新思想新战略，创立了习近平新时代中国特色社会主义思想，实现了马克思主义中国化时代化新的飞跃。科学的理论武装是一切实践的行动指南，中国共产党始终坚持用马克思主义科学理论武装头脑、指导实践，党的二十大将全面贯彻新时代中国特色社会主义思想作为主题的重要内容，必将鼓舞全党和全国各族人民始终做到心往一处想、劲往一处使，把全面贯彻习近平新时代中国特色社会主义思想贯穿到各项工作的全过程和各环节，进一步感悟思想伟力，增强用习近平新时代中国特色社会主义思想凝心铸魂的政治自觉和思想自觉，在新的赶考之路上不断实现新的胜利。</p>
        <p>伟大建党精神是新征程上必须传承发扬的强大精神法宝</p>
        <p>人无精神不立、党无精神不兴。伟大建党精神是中国共产党的精神之源。中国共产党坚持弘扬伟大建党精神，在伟大建党精神中找寻中国共产党是什么、要干什么这个根本问题的答案，是确保中国共产党作为马克思主义执政党的性质不变质、不变色、不变味的精神支撑。党的二十大把伟大建党精神写入大会主题，是中国共产党人在新征程上保持昂扬精神状态的重大宣示，明确了新征程上中国共产党的强大精神法宝，意蕴着广大党员干部要不断接受理想信念的精神淬炼，汲取奋勇前进的精神力量，牢固厚植中国共产党的宝贵精神品质，将伟大建党精神融入实现中华民族伟大复兴的实践中，让伟大建党精神转化为当代中国共产党人奋斗的精神动力，号召广大中国共产党人自信自强、守正创新，踔厉奋发、勇毅前行，自觉挺起共产党人的精神脊梁，为践行好新时代中国共产党人的价值观提供鲜明指向。</p>
        <p>全面建设社会主义现代化国家、全面推进中华民族伟大复兴是新征程上必须坚定实现的伟大目标</p>
        <p>实现国家现代化和中华民族伟大复兴是近代以来中国人民的美好夙愿。二十大报告指出，“从现在起，中国共产党的中心任务就是团结带领全国各族人民全面建成社会主义现代化强国、实现第二个百年奋斗目标，以中国式现代化全面推进中华民族伟大复兴。”这是新时代、新征程全党必须坚定贯彻落实的新要求、新战略。这一要求启发着广大中国共产党人必须永葆党的旺盛生命力和强大战斗力，把中国特色社会主义各项事业发展好、巩固好，努力形成各项事业相互促进、共同发力的积极态势，不断汇聚全面建设社会主义现代化国家和全面推进中华民族伟大复兴的强大力量。</p>
        <p>中国共产党是有理想、有追求、有担当的马克思主义政党，党的二十大主题贯穿着历史、现实和未来，是党的立场、观点和原则的集中反映，充分彰显了中国共产党人牢记初心使命、继往开来前行的强大自信与定力，鲜明昭示着伟大旗帜、根本指导思想、强大精神法宝、伟大目标统一于党和国家事业的新征程。要深刻领会党的二十大主题的深邃意蕴，更加自觉树立起坚定不移听党话、永葆忠诚跟党走的不变信念，奋力投身新的伟大斗争，依靠顽强斗争打开事业发展新天地。</p>
        <p style="text-indent: 0; font-weight: 700">声明:转载此文是出于传递更多信息、利于普法之目的。若有来源标注错误或侵犯了您的合法权益，请作者持权属证明与广东东进联系，我们将及时更正、删除，谢谢。</p>
      </div>
      <br />
      <br />
      <el-row :gutter="20">
        <el-col :span="12" :xs="24" :offset="0">
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build3' })"
            >&lt; 上一条&nbsp;&nbsp;&nbsp;&nbsp;深刻领会党的二十大的主题! </span
          >
        </el-col>
        <el-col
          :span="12"
          :xs="24"
          :offset="0"
          style="text-align: right"
          class="hidden-xs-only"
        >
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build1' })"
            >习近平：高举中国特色...&nbsp;&nbsp;&nbsp;&nbsp;下一条 &gt;</span
          >
        </el-col>
        <el-col :span="12" :xs="24" :offset="0" class="hidden-sm-and-up">
          <span
            style="cursor: pointer; color: #666; font-size: 14px"
            @click="$router.push({ name: 'Build1' })"
            >下一条 &gt; &nbsp;&nbsp;&nbsp;&nbsp;习近平：高举中国特色...</span
          >
        </el-col>
      </el-row>
      <br />
      <br />
    </el-card>
    <br class="hidden-xs-only" />
    <div class="kongxi hidden-sm-and-up"></div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      img: [require('@/assets/news5.png')]
    }
  }
}
</script>

<style lang="scss" scoped>
.kongxi {
  height: 10px;
}
.content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
@media screen and (max-width: 768px) {
  .content {
      width: 90%;
      margin: 0 auto;

      h2 {
        font-family: 黑体, SimHei;
        font-size: 24px;
        margin: 20px 0;
        text-align: center;
      }

      p {
        font-size: 16px;
        margin: 20px 0;
        text-align: justify;
        text-indent: 2em;
        color: #515050;
        font-family: "Microsoft YaHei", Verdana, Geneva, sans-serif;
      }
    }
}
</style>
